import type { NumberFormatOptions } from 'next-intl';
import type { SearchCategory, SearchTab } from './types';

export const SEARCH_DEBOUNCE_MS = 300;
export const MIN_SEARCH_LENGTH = 2;
/** Rows per section on the empty search and under All. */
export const SECTION_LIMIT = 3;
/** Rows on a category's own tab. */
export const TAB_LIMIT = 10;
/** Rows on a category's tab before anything is typed: its top picks. */
export const PREVIEW_LIMIT = 6;
export const RECENT_LIMIT = 8;

export const RECENT_SEARCHES_KEY = 'outpoll:search:recent';

/** The categories in the order the tabs and the All sections read. */
export const SEARCH_CATEGORIES: readonly SearchCategory[] = [
  'crypto',
  'predictions',
  'traders',
  'news',
];

/** Every tab, always on screen: All, then the categories. */
export const SEARCH_TABS: readonly SearchTab[] = ['all', ...SEARCH_CATEGORIES];

/** A first character that picks a tab instead of being searched: `@nickname`, `$ticker`. */
export const TAB_PREFIXES: Readonly<Partial<Record<string, SearchCategory>>> = {
  '@': 'traders',
  $: 'crypto',
};

/** How long the field takes to grow into the panel and fold back. */
export const PANEL_MOTION_MS = 340;

export const WHOLE_USD_FORMAT: NumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
};

export const EMPTY_VALUE = '—';
